import { Type } from 'class-transformer';
import { IsArray, IsIn, IsOptional, IsString, IsUUID, ValidateNested } from 'class-validator';
import {
  LABEL_GATE_DISCOVERY_REASONS,
  type LabelGateDiscoveryReason,
} from './label-gate-discovery-reason.enum';

/**
 * One discovered row in the 409 confirmation-gate response (plan.md "Gate di
 * conferma"). `lineId` is present for row-level reasons (a specific
 * `RecipeIngredient` or `IngredientComponent`) and absent for subject-level
 * reasons (missing `legalName`, missing milk on a protected dairy name,
 * graph too deep) — the panel groups discovered lines by presence/absence
 * of `lineId`.
 */
export class LabelGateDiscoveredLineDto {
  @IsOptional()
  @IsUUID()
  lineId?: string;

  @IsString()
  lineLabel!: string;

  @IsArray()
  @IsIn(LABEL_GATE_DISCOVERY_REASONS, { each: true })
  reasons!: LabelGateDiscoveryReason[];
}

export class LabelGateResponseDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => LabelGateDiscoveredLineDto)
  discoveredLines!: LabelGateDiscoveredLineDto[];
}
